import { RootState } from '../../../app/reducer.web';

export const selectAudioIsPlaying = ({ webReducer }: RootState): boolean =>
  webReducer.audioIsPlaying;
